import { createContext, ReactNode, useMemo, useReducer } from 'react';

import {
  clearAllNotificationsAction,
  deleteNotificationAction,
  notificationOpenAction,
  showNotificationAction,
} from './actions/notificationActions';
import notificationReducer, {
  INotificationReducer,
  notificationReducerState,
  INotificationData,
} from './reducer/notificationReducer';

interface INotificationProviderProps {
  children: ReactNode;
}

const NotificationContext = createContext<INotificationReducer>(notificationReducerState);

const NotificationsProvider = ({ children }: INotificationProviderProps): JSX.Element => {
  const [state, dispatch] = useReducer(notificationReducer, notificationReducerState);
  const notificationOpen = (notificationData: INotificationData): void => {
    dispatch(notificationOpenAction(notificationData));
  };
  const setShowNotification = (notification: boolean): void => {
    dispatch(showNotificationAction(notification));
  };

  const deleteNotification = (notificationId: string | number): void => {
    dispatch(deleteNotificationAction(notificationId));
  };

  const clearAllNotifications = (): void => {
    dispatch(clearAllNotificationsAction());
  };

  const notificationContextValue = useMemo(
    () => ({
      contentData: state.contentData,
      showNotification: state.showNotification,
      notificationOpen,
      setShowNotification,
      deleteNotification,
      clearAllNotifications,
    }),
    [state],
  );

  return <NotificationContext.Provider value={notificationContextValue}>{children}</NotificationContext.Provider>;
};

export { NotificationsProvider, NotificationContext };
